export * from './translate.service';
export * from './translate.service.interface';
